import { FC, MouseEventHandler, memo } from 'react';
import cn from 'classnames';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import styles from './ProjectSliderControl.module.css';

interface ProjectSliderControl {
  onPrev: MouseEventHandler<HTMLButtonElement>;
  onNext: MouseEventHandler<HTMLButtonElement>;
}

const ProjectSliderControl: FC<ProjectSliderControl> = ({ onPrev, onNext }) => (
  <div className={styles.control}>
    <button
      className={cn(styles.leftControl)}
      onClick={onPrev}
      aria-label="Previous Project Image"
    >
      <FaArrowLeft />
    </button>
    <button
      className={cn(styles.rightControl)}
      onClick={onNext}
      aria-label="Next Project Image"
    >
      <FaArrowRight />
    </button>
  </div>
);

export default memo(ProjectSliderControl);
